import BaseVue from '@/base/BaseVue';
import {Options} from 'vue-class-component';
import MiTitle from '@/components/title/Title.vue';
import HttpBase from '@/http/base/HttpBase';

@Options({
  components: {
    'mi-title': MiTitle
  }
})
export default class EditShop extends BaseVue {
  place: any = [];
  uploadData2:any=null
  uploadData3:any=null
  localhostUploadUrl = `${HttpBase.getRootUrl()}/file/imgUpdate`;
  // uploadUrl = `${HttpBase.getRootUrl()}/file/imgUpdate`;
  uploadUrl = HttpBase.QiNiu_URL;
  uploadData: any = {};
  ruleForm = {
    img: '',
    mode: '',
    name: '',
    notes: '',
    audio: '',
  };
  rules = {
    mode: [
      {required: true, message: '请填写', trigger: 'blur'},
    ],
    img: [
      {required: true, message: '请填写', trigger: 'blur'},
    ],
    name: [
      {required: true, message: '请填写', trigger: 'blur'},
    ],
    notes: [
      {required: true, message: '请填写', trigger: 'blur'},
    ],

    audio: [
      {required: true, message: '请填写', trigger: 'blur'},
    ],
  };

  async beforeImageUpload(rawFile: any) {
    if (rawFile.size / 1024 / 1024 > 50) {
      this.toast_warn('单张图片大小不能超过50MB!');
      return false;
    }
    let name:string=rawFile.name
    name=name.substring(name.lastIndexOf("."))
    const data = await this.http.getImageQiNiuUploadToken({suffix:name});
    this.uploadData = data.data;
    return true;
    // const data = await this.http.getImageQiNiuUploadToken();
    // this.uploadData = data.data;
    // console.log(this.uploadData);
  }


  async beforeImageUpload3(rawFile: any) {
    if (rawFile.size / 1024 / 1024 > 50) {
      this.toast_warn('单张图片大小不能超过50MB!');
      return false;
    }
    // let name:string=rawFile.name
    // name=name.substring(name.lastIndexOf("."))
    // const data = await this.http.getImageQiNiuUploadToken({suffix:name});
    // this.uploadData = data.data;
    // return true;
    // // const data = await this.http.getImageQiNiuUploadToken();
    // this.uploadData = data.data;
    // console.log(this.uploadData);
  }

  async beforeImageUpload2(rawFile: any) {
    if (rawFile.size / 1024 / 1024 > 50) {
      this.toast_warn('单张图片大小不能超过50MB!');
      return false;
    }
    let name:string=rawFile.name
    name=name.substring(name.lastIndexOf("."))
    const data = await this.http.getImageQiNiuUploadToken({suffix:name});
    this.uploadData2 = data.data;
    return true;
    // const data = await this.http.getImageQiNiuUploadToken();
    // this.uploadData = data.data;
    // console.log(this.uploadData);
  }

  // 上传成功，获取返回的图片地址
  handleUpImage(res: any) {
    // this.ruleForm.img = `${HttpBase.getRootUrl()}/file/getImage/${res.data}`;
    this.ruleForm.img =  this.uploadData.prefix + res.key;
  }

  // 上传成功，获取返回的图片地址
  handleUpImage2(res: any) {
    this.ruleForm.mode = `${HttpBase.getRootUrl()}/file/getImage/${res.data}`;
  }

  handleUpImage3(res: any) {
    // this.ruleForm.audio = `${HttpBase.getRootUrl()}/file/getAudioFile/${res.data}`;
    this.ruleForm.audio = this.uploadData2.prefix + res.key;
  }

  // 上传成功，获取返回的图片地址
  handleUpImage1(res: any) {
    console.log(111, res);
    // @ts-ignore
    this.ruleForm.imgs.push({url: `${HttpBase.getRootUrl()}/file/getImage/${res.data}`});
  }

  handleRemove(uploadFile: any, uploadFiles: any) {
    let url = '';
    Object.keys(uploadFile).forEach(item => {
      url += uploadFile[item];
    });
    // @ts-ignore

    this.ruleForm.imgs.splice(this.ruleForm.imgs.indexOf(this.ruleForm.imgs.find((res: any) => {
      return res.url == url;
    })), 1);
  }

  submitForm(item: any) {
    this.http.editJingLin(this.ruleForm).then(res => {
      this.toast_success(res.msg);
      this.resetForm('refForm');
    }).catch(res => {
      this.toast_error(res.msg);
    });
  }
  mounted() {
    this.http.getJinlingDetail({id: this.getParameters().id}).then(res => {
      this.ruleForm = res.data;
      // this.ruleForm.imgs = imgs;
    }).catch(res => {
      this.toast_error(res.msg);
    });
  }

}
